import {ManyResponse} from '../../../responses/many.response';
import {BaseUnitTimes} from '../models';
import {Injectable} from '@angular/core';
import {TorchAPIConfiguration} from '../../../config/api.configuration';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Burly} from 'kb-burly';
import {SortDirection} from '@angular/material/sort';

@Injectable({
  providedIn: 'root'
})
export class TorchUnitTimesService {

  constructor(protected config: TorchAPIConfiguration, private httpClient: HttpClient) {
  }

  public getUnitTimes(pageSize: number = 15,
                      currentPage: number = 0,
                      sortDirection?: SortDirection,
                      sortBy?: string,
                      filter?: string | string[],
                      orFilter?: string | string[]): Observable<ManyResponse<BaseUnitTimes>> {

    let finalURL;
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/unit-times')
      .addQuery('page', (currentPage + 1))
      .addQuery('limit', pageSize);

    if (sortDirection && sortBy) {
      endpoint.addQuery('sort', `${sortBy},${sortDirection.toUpperCase()}`);
    }

    finalURL = endpoint.get;

    if (filter) {
      if (filter instanceof Array) {
        if (filter.length > 0) {
          filter.forEach(filterValue => {
            finalURL = `${finalURL}&filter=${encodeURIComponent(filterValue)}`;
          });
        }
      } else {
        finalURL = `${finalURL}&or=${encodeURIComponent(filter)}`;
      }
    }

    if (orFilter) {
      if (orFilter instanceof Array) {
        if (orFilter.length > 0) {
          orFilter.forEach((filterValue, index) => {
            if (index === 0) {
              finalURL = `${finalURL}&filter=${encodeURIComponent(filterValue)}`;
            } else {
              finalURL = `${finalURL}&or=${encodeURIComponent(filterValue)}`;
            }
          });
        }
      } else {
        finalURL = `${finalURL}&or=${encodeURIComponent(orFilter)}`;
      }
    }

    return this.httpClient.get<ManyResponse<BaseUnitTimes>>(finalURL);
  }

  public exportUnitsToExcel(units: BaseUnitTimes[]) {
    return new Observable(subscriber => {
      const endpoint = Burly(this.config.rootUrl)
        .addSegment('/unit-times')
        .addSegment('/export')
        .get;

      const httpOptions: { headers; observe; responseType } = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        observe: 'response',
        responseType: 'blob'
      };

      const body = {units};

      this.httpClient.post(endpoint, body, httpOptions).subscribe((response) => {
        subscriber.next((response as unknown as HttpResponse<any>).body);
        subscriber.complete();
      });
    });
  }
}
